/*
 *  Copyright (c) Qwoach LLC 2026. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 */

import BaseIdObject from "@shared/BaseIdObject";
import WheelSegmentItem from "@shared/WheelModel/WheelSegmentItem";
import {Type} from "@qwoach/class-transformer-wrapper";
import {TlswStageEnum} from "@shared/TlswMeasure/TlswStageEnum";
import {TlswAudienceEnum} from "@shared/TlswMeasure/TlswAudienceEnum";

export default class TlswMeasureStageResponse extends BaseIdObject {

	@Type(() => WheelSegmentItem)
	segments: WheelSegmentItem[] = []

	createdAt: number = null
	stage: string = TlswStageEnum.STAGE_INITIAL
	audience: string = TlswAudienceEnum.AUDIENCE_ADULT

	childName: string = null
	childAge: string = null
	peopleSupporting: string = null
	whyNow: string = null
	outcomesHoped: string = null
	actualOutcomes: string = null

	completedBy: string = null
	roleInChildLife: string = null
	completedDate: number = null

	constructor(options = {}) {
		super();
		this.stage = options.stage || this.stage
		this.audience = options.audience || this.audience
		this.segments = options.segments || []
		this.createdAt = options.createdAt || new Date().getTime()

		this.childName = options.childName || this.childName
		this.childAge = options.childAge || this.childAge
		this.peopleSupporting = options.peopleSupporting || this.peopleSupporting
		this.whyNow = options.whyNow || this.whyNow
		this.outcomesHoped = options.outcomesHoped || this.outcomesHoped
		this.actualOutcomes = options.actualOutcomes || this.actualOutcomes

		this.completedBy = options.completedBy || this.completedBy
		this.roleInChildLife = options.roleInChildLife || this.roleInChildLife
		this.completedDate = options.completedDate || this.completedDate
	}
}
